import React from "react";
import { useSelector } from "react-redux";
import { useLocation, NavLink } from "react-router-dom";
import classNames from "classnames";

import { getStepUrl, getStepIndex } from "../../helpers/steps";
import { selectIsOperator, selectLastStep } from "../../store/selectors";

const NavigateBackward = () => {
  const location = useLocation();
  const isOperator = useSelector(selectIsOperator);

  if (!location || !isOperator) return null;

  const step = Number(getStepIndex(location.pathname));

  let prevStep = step - 1;
  const [prevStepUrl] = getStepUrl(prevStep);
  if (prevStepUrl?.indexOf("confirmation") > -1) prevStep--;
  const url = prevStep > -1 ? getStepUrl(prevStep)[0] : null;
  const disabled = !url || step === 0;

  const state = {};
  if (prevStep > 0) {
    state.direction = "backward";
  }

  return (
    <NavLink
      to={{
        pathname: !disabled ? url : "",
      }}
      state={state}
      className={classNames("btn", "btn_primary", { disabled })}>
      <span>Назад</span>
    </NavLink>
  );
};

const NavigateForward = () => {
  const location = useLocation();
  const isOperator = useSelector(selectIsOperator);
  const lastStepUrl = useSelector(selectLastStep);

  if (!location || !isOperator) return null;

  const lastStep = lastStepUrl ? Number(getStepIndex(lastStepUrl)) : 0;
  const step = Number(getStepIndex(location.pathname));

  let nextStep = step + 1;
  const [nextStepUrl] = getStepUrl(nextStep);
  if (nextStepUrl?.indexOf("confirmation") > -1) nextStep++;
  const url = getStepUrl(nextStep)[0];

  const disabled = !url || step >= lastStep;
  return (
    <NavLink
      to={!disabled ? url : ""}
      className={classNames("btn", "btn_primary", { disabled })}>
      <span>Вперед</span>
    </NavLink>
  );
};

export const OperatorNavigation = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      padding: "10px",
      gap: "10px",
    }}>
    <NavigateBackward />
    <NavigateForward />
  </div>
);
